<template>
	<div>
		<!-- MOCK: for Apeiron -->
		<template v-if="['apeiron_uat', 'apeiron'].includes($store.state.tenantId)">
			<apeiron-internals-detail />
		</template>

		<!-- default internals detail -->
		<template v-else>
			<default-internals-detail />
		</template>
	</div>
</template>

<script>
import api from "../api"
import get from "lodash.get"

import DefaultInternalsDetail from "../components/DefaultInternalsDetail"
import ApeironInternalsDetail from "../components/mockedApeiron/ApeironInternalsDetail"

export default {
	components: {
		DefaultInternalsDetail,
		ApeironInternalsDetail
	},

	data() {
		return {
			id: this.$route.params.id,
			fetchedInternal: {}
		}
	},

	methods: {
		async fetchInternal() {
			this.isLoading = true
			const res = await api.internal({
				where: { id: this.id }
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// If it doesn't exist, redirect
			if (res.data.internals.list.length === 0)
				this.$router.push({ name: "InternalsList" })

			// Assign
			this.fetchedInternal = res.data.internals.list[0]
		},

		async onDelete(id) {
			this.isLoading = true
			const res = await api.deleteInternal({ id })
			this.isLoading = false

			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}

			// go back to previous page
			if (res) this.$router.push(`/${this.$store.state.tenantId}/internals/`)
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("participant_deleted")
				}
			})
		}
	},

	computed: {
		hasAssociatedLogin() {
			return get(this, "fetchedInternal.associatedLogin[0].id") ? true : false
		}
	},

	created() {
		this.fetchInternal()
	}
}
</script>

<style></style>
